import React from 'react';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import img3 from '../docpat.jpg';

function CardTwo() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid item>
      <Grid container justifyContent="center" alignItems="center" sx={{ padding: '20px' }}>
        <Grid item xs={12} md={6} sx={{ padding: isSmallScreen ? '10px' : '18px' }}>
          <img
            src={img3}
            alt="Third Half Image"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Grid>
        <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: 1 }, textAlign: 'center' }}>
          <Typography variant="h3" sx={{ marginBottom: '10px', fontSize: '35px', fontWeight: 500 }}>
            Invisalign
          </Typography>
          <Typography
            sx={{
              fontSize: '20px',
              marginBottom: '15px',
              lineHeight: '2.0',
              paddingLeft: isSmallScreen ? '10px' : '25px',
              paddingRight: isSmallScreen ? '10px' : '25px'
            }}
          >
            Invisalign is a cutting-edge alternative to conventional metal braces for children and
            adults. Our orthodontists recommend these digital series of aligners for several
            reasons. The trays can be easily removed while eating and brushing. Being transparent,
            the aligners allow working people to feel less self-conscious. The teeth straightening
            process can be completed in less than a year.
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default CardTwo;
